import axios from '../../app/api/axios';
import {
    INSTITUTIONS_DETAILS_REQUEST,
    INSTITUTIONS_DETAILS_SUCCESS,
    INSTITUTIONS_DETAILS_FAILURE,
    INSTITUTIONS_LIST_REQUEST,
    INSTITUTIONS_LIST_SUCCESS,
    INSTITUTIONS_LIST_FAILURE,
    SET_INSTITUTIONS_SEARCH_CRITERIA,
    TOGGLE_DRAWER_MOBILE_FILTER_SEARCH,
    INSTITUTIONS_TYPES_REQUEST,
    INSTITUTIONS_TYPES_SUCCESS,
    INSTITUTIONS_TYPES_FAILURE,
    INSTITUTIONS_DROPDOWN_REQUEST,
    INSTITUTIONS_DROPDOWN_SUCCESS,
    INSTITUTIONS_DROPDOWN_FAILURE,
    GET_INSTITUTIONS_AGES_REQUEST,
    GET_INSTITUTIONS_AGES_SUCCESS,
    GET_INSTITUTIONS_AGES_FAILURE,
} from './types';
import { getCache, setCache } from "../../app/api/cache";

// --- Types ---
export const getInstitutionsTypes = () => async dispatch => {
    dispatch({ type: INSTITUTIONS_TYPES_REQUEST });
    const cacheKey = 'api_get_institutions_taxonomy_type';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({ type: INSTITUTIONS_TYPES_SUCCESS, payload: cached });
        return;
    }

    try {
        const res = await axios.get('agep/v1/institutions/taxonomy/type');
        dispatch({ type: INSTITUTIONS_TYPES_SUCCESS, payload: res.data });
        setCache(cacheKey, res.data);
    } catch (err) {
        dispatch({ type: INSTITUTIONS_TYPES_FAILURE, payload: err.response ? err.response.data : { message: err.message } });
    }
};

// --- Ages ---
export const getInstitutionsAges = () => async dispatch => {
    dispatch({ type: GET_INSTITUTIONS_AGES_REQUEST });
    try {
        const res = await axios.get('agep/v1/institutions/taxonomy/age'); // ton endpoint WS
        dispatch({
            type: GET_INSTITUTIONS_AGES_SUCCESS,
            payload: res.data
        });
    } catch (err) {
        dispatch({ type: GET_INSTITUTIONS_AGES_FAILURE, error: err });
    }
};

// --- Dropdown ---
export const getInstitutionsDropdown = () => async dispatch => {
    dispatch({ type: INSTITUTIONS_DROPDOWN_REQUEST });
    const cacheKey = 'api_get_institutions_dropdown';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({ type: INSTITUTIONS_DROPDOWN_SUCCESS, payload: cached });
        return;
    }

    try {
        const res = await axios.get('agep/v1/institutions_dropdown');
        const data = Array.isArray(res.data.posts) ? res.data.posts : [];
        dispatch({ type: INSTITUTIONS_DROPDOWN_SUCCESS, payload: data });
        setCache(cacheKey, data);
    } catch (err) {
        dispatch({ type: INSTITUTIONS_DROPDOWN_FAILURE, payload: err.response ? err.response.data : { message: err.message } });
    }
};

// --- Listing institutions ---
export const getInstitutionsList = (page = 1, newSearch = false, type = '', selectedInstitution = '', age = '') => async dispatch => {
    dispatch({ type: INSTITUTIONS_LIST_REQUEST });

    try {
        const res = await axios.post('agep/v1/institutions', { page, type, selectedInstitution, age });
        dispatch({ type: INSTITUTIONS_LIST_SUCCESS, payload: res.data, page, newSearch, fakeLoadingTime: 0 });
    } catch (err) {
        dispatch({ type: INSTITUTIONS_LIST_FAILURE, payload: err.response ? err.response.data : { message: err.message } });
    }
};

// --- Détails institution ---
export const getInstitutionsDetails = (slug) => async dispatch => {
    dispatch({ type: INSTITUTIONS_DETAILS_REQUEST });
    try {
        const res = await axios.get(`agep/v1/institution/${slug}`);
        dispatch({ type: INSTITUTIONS_DETAILS_SUCCESS, payload: res.data });
    } catch (err) {
        dispatch({ type: INSTITUTIONS_DETAILS_FAILURE, payload: err.response ? err.response.data : { message: err.message } });
    }
};

// --- Critères de recherche ---
export const setInstitutionsSearchCriteria = (criteria = {}) => dispatch => {
    dispatch({ type: SET_INSTITUTIONS_SEARCH_CRITERIA, payload: criteria });
};

// --- Drawer ---
export const toggleDrawerMobileFilterSearch = () => dispatch => {
    dispatch({ type: TOGGLE_DRAWER_MOBILE_FILTER_SEARCH });
};



// WEBPACK FOOTER //
// ./src/features/Institutions/actions.js